import environment from "@/environment";
import type { EventLogger } from "@/app/eventlogging/eventCollectorEventLogger";
import {
  commonBrowserPropertiesDecorator,
  NoopLogger,
  EventCollectorEventLogger,
  commonNavigationPropertiesDecorator,
  ConsoleLogger,
} from "@/app/eventlogging/eventCollectorEventLogger";

const eventLogger: EventLogger =
  environment.isProduction || environment.isStaging
    ? new EventCollectorEventLogger([
        commonNavigationPropertiesDecorator,
        commonBrowserPropertiesDecorator,
      ])
    : environment.eventLoggerLogEventsToConsoleInDevelopment
      ? new ConsoleLogger()
      : new NoopLogger();

export default eventLogger;
